export const CRMErrors = {
	undefinedProvider: 'undefinedProvider',
};
